
  jQuery.validator.setDefaults({
    ignore: [],
    focusInvalid: false,
    invalidHandler: function(form, validator) {
      if (!validator.numberOfInvalids())
        return;
      var elem = validator.errorList[0].element.id;

      $(window).scrollTo("#" + elem, 200, {
        offset: -160,
        queue: false,
        onAfter: function() {
          $("#" + elem).focus();
        }
      });
    },
    onfocusout: false,

    showErrors: function(errorMap, errorList) {
      blnValidated_at_least_once = true;
      $.each(this.successList, function(index, value) {

        var _popover = $(value).popover({
          trigger: 'manual',
          placement: 'top',
          content: value.message,
          container: '.form-group',
          template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-content"></div></div>'
        });

        $(value).popover('hide');
      });
      var x_count = 0;
      $.each(errorList, function(index, value) {
        // console.log($(value.element)[0].type);
        // console.log($(value.element).attr('data-popover-selector'));
        if (x_count > 0) {

        } else {
          x_count++;

          if ($(value.element)[0].type == "hidden") {
            var popover_selector = $(value.element).attr('data-popover-selector');
            var _popover = $(popover_selector).popover({
              trigger: 'manual',
              placement: 'top',
              content: '',
              container: 'body',
              template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-content"></div></div>'
            });

            $(popover_selector).attr('data-content', value.message);

            _popover.popover('show');
            setTimeout(function() {
              $(popover_selector).popover('hide');
            }, 4000);

          } else {

            var _popover = $(value.element).popover({
              trigger: 'manual',
              placement: 'top',
              content: '',
              container: 'body',
              template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><div class="popover-content"></div></div>'
            });

            $(value.element).attr('data-content', value.message);

            _popover.popover('show');

            setTimeout(function() {
              $(value.element).popover('hide');
            }, 4000);

          }
        }
      });
    }
  });

  if ($("html").hasClass("ie8")) {
  } else {
    if (!window.addEventListener) {
      window.attachEvent("onorientationchange", doOrientationChange);
    }
    else {
      window.addEventListener("onorientationchange", doOrientationChange);
    }
    //window.xhandleResize();
  }



/// resizing handlers

var xhandleResize = function(form_element_id) {
  $(window).one("resize", function() {
    if (!Modernizr.touch) {
      $(form_element_id + 'input[type=text]', form_element_id + 'input[type=password]', form_element_id + 'input[type=checkbox]', form_element_id + 'select').each(function() {
        if ($(this).attr("id") == "confirm") {
          var offset = $(this).offset();
          var ol = offset.left - 59;
          var ot = offset.top + 13;
          $(this).parent('.checkbox').find('.tooltip').css({
            'left': ol + 'px',
            'top': ot + 'px'
          });
        } else {
          $(this).blur();
        }
      });
    }
    setTimeout("xhandleResize()", 200);
  });
}
var x_reposition = function(form_element_id) {
  $(form_element_id + 'input[type=text]', form_element_id + 'input[type=password]', form_element_id + 'input[type=checkbox]', form_element_id + 'select', form_element_id + 'textarea').find(":visible").each(function() {
    $(form_element_id + 'input[type=text]', form_element_id + 'input[type=password]', form_element_id + 'input[type=checkbox]', form_element_id + 'select', form_element_id + 'textarea').find(":visible").each(function() {
      if ($(this).attr("id") == "confirm") {
        var offset = $(this).offset();
        var ol = offset.left - 59;
        var ot = offset.top + 13;
        $(this).parent('.checkbox').find('.tooltip').css({
          'left': ol + 'px',
          'top': ot + 'px'
        });
      } else {
        $(this).blur();
      }
    });
  });
};

function doOrientationChange(form_element_id) {
  x_reposition(form_element_id);
}
